import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_fontawesome_7d665724 from 'nuxt_plugin_fontawesome_7d665724' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_tfs_388a9de8 from 'nuxt_plugin_tfs_388a9de8' // Source: ../plugins/tfs.js (mode: 'client')
import nuxt_plugin_nexus_4819370e from 'nuxt_plugin_nexus_4819370e' // Source: ../plugins/nexus.js (mode: 'all')
import nuxt_plugin_search_4c6406ce from 'nuxt_plugin_search_4c6406ce' // Source: ../plugins/search.js (mode: 'all')
import nuxt_plugin_member_564a132e from 'nuxt_plugin_member_564a132e' // Source: ../plugins/models/member.js (mode: 'all')
import nuxt_plugin_cart_ae2f45b0 from 'nuxt_plugin_cart_ae2f45b0' // Source: ../plugins/models/cart.js (mode: 'all')
import nuxt_plugin_educator_e3e1f2b6 from 'nuxt_plugin_educator_e3e1f2b6' // Source: ../plugins/models/educator.js (mode: 'all')
import nuxt_plugin_configs_16d19a16 from 'nuxt_plugin_configs_16d19a16' // Source: ../plugins/models/configs.js (mode: 'all')
import nuxt_plugin_player_d2976cf2 from 'nuxt_plugin_player_d2976cf2' // Source: ../plugins/models/player.js (mode: 'all')
import nuxt_plugin_course_5da8420d from 'nuxt_plugin_course_5da8420d' // Source: ../plugins/models/course.js (mode: 'all')
import nuxt_plugin_itj_0032e887 from 'nuxt_plugin_itj_0032e887' // Source: ../plugins/models/itj.js (mode: 'all')
import nuxt_plugin_item_05ff7455 from 'nuxt_plugin_item_05ff7455' // Source: ../plugins/models/item.js (mode: 'all')
import nuxt_plugin_plusnetwork_b9c15604 from 'nuxt_plugin_plusnetwork_b9c15604' // Source: ../middleware/plusnetwork (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Online Guitar Lessons - Learn Guitar with the Best Online Guitar Lessons and Guitar Teachers - TrueFire","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"name":"format-detection","content":"telephone=no"},{"name":"appleid-signin-client-id","content":"com.truefire.applesignin"},{"name":"appleid-signin-scope","content":"email"},{"name":"appleid-signin-redirect-uri","content":"https:\u002F\u002Ftruefire.com\u002Fonline-guitar-lessons"},{"name":"appleid-signin-state","content":"origin:web"},{"name":"fb:app_id","content":"143023449058870"},{"name":"robots","content":"index"},{"name":"apple-itunes-app","content":"app-id=690143001"},{"name":"og:title","content":"Online Guitar Lessons - TrueFire"},{"name":"og:url","content":"https:\u002F\u002Ftruefire.com"},{"name":"og:type","content":"website"},{"name":"facebook-domain-verification","content":"9cdrz60me3c61wl42zrq747moougpl"},{"name":"google-signin-client_id","content":"185148738742-0723kgb7no0jc0iofhoam2v6mr3jsqo3.apps.googleusercontent.com"},{"name":"ahrefs-site-verification","content":"ec6ce77380f840610b9343e8ab8c02f321e0b96f7a1b5a8c278fa10bdfee3099"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"@truefiretv"},{"name":"twitter:creator","content":"@truefiretv"},{"name":"twitter:title","content":"Online Guitar Lessons - TrueFire"}],"script":[{"src":"https:\u002F\u002Fstaticw2.yotpo.com\u002F4otGQGQZiVamGX22LVlmFeddVLn9oJKVoK0KHnyc\u002Fwidget.js","defer":true},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@algolia\u002Fautocomplete-js","defer":false},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@algolia\u002Fautocomplete-plugin-query-suggestions","defer":false},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Falgoliasearch@5.23.0\u002Fdist\u002Falgoliasearch.umd.js","defer":false}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fcdn.truefire.com\u002Fimages\u002Ffavicon.ico"},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Froboto\u002Fv30\u002FKFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Froboto\u002Fv30\u002FKFOlCnqEu92Fr1MmWUlfBBc4AMP6lQ.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Froboto\u002Fv30\u002FKFOlCnqEu92Fr1MmEU9fBBc4AMP6lQ.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Fd2xkd1fof6iiv9.cloudfront.net\u002Faa.css","type":"text\u002Fcss","crossorigin":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_7d665724 === 'function') {
    await nuxt_plugin_fontawesome_7d665724(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tfs_388a9de8 === 'function') {
    await nuxt_plugin_tfs_388a9de8(app.context, inject)
  }

  if (typeof nuxt_plugin_nexus_4819370e === 'function') {
    await nuxt_plugin_nexus_4819370e(app.context, inject)
  }

  if (typeof nuxt_plugin_search_4c6406ce === 'function') {
    await nuxt_plugin_search_4c6406ce(app.context, inject)
  }

  if (typeof nuxt_plugin_member_564a132e === 'function') {
    await nuxt_plugin_member_564a132e(app.context, inject)
  }

  if (typeof nuxt_plugin_cart_ae2f45b0 === 'function') {
    await nuxt_plugin_cart_ae2f45b0(app.context, inject)
  }

  if (typeof nuxt_plugin_educator_e3e1f2b6 === 'function') {
    await nuxt_plugin_educator_e3e1f2b6(app.context, inject)
  }

  if (typeof nuxt_plugin_configs_16d19a16 === 'function') {
    await nuxt_plugin_configs_16d19a16(app.context, inject)
  }

  if (typeof nuxt_plugin_player_d2976cf2 === 'function') {
    await nuxt_plugin_player_d2976cf2(app.context, inject)
  }

  if (typeof nuxt_plugin_course_5da8420d === 'function') {
    await nuxt_plugin_course_5da8420d(app.context, inject)
  }

  if (typeof nuxt_plugin_itj_0032e887 === 'function') {
    await nuxt_plugin_itj_0032e887(app.context, inject)
  }

  if (typeof nuxt_plugin_item_05ff7455 === 'function') {
    await nuxt_plugin_item_05ff7455(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plusnetwork_b9c15604 === 'function') {
    await nuxt_plugin_plusnetwork_b9c15604(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
